import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUser, FiBuilding, FiCalendar, FiEuro, FiFileText } = FiIcons;

const ClientCard = ({ client }) => {
  const statusConfig = {
    nuovo_lead: { label: 'Nuovo Lead', color: 'blue', bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
    in_trattativa: { label: 'In Trattativa', color: 'orange', bg: 'bg-orange-50', text: 'text-orange-700', border: 'border-orange-200' },
    cliente_acquisito: { label: 'Cliente Acquisito', color: 'green', bg: 'bg-green-50', text: 'text-green-700', border: 'border-green-200' },
    pagato: { label: 'Pagato', color: 'emerald', bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    commissionato: { label: 'Commissionato', color: 'purple', bg: 'bg-purple-50', text: 'text-purple-700', border: 'border-purple-200' }
  };

  const status = statusConfig[client.status] || statusConfig.nuovo_lead;

  return (
    <motion.div
      whileHover={{ y: -2 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 mb-1">{client.contactName}</h3>
          <p className="text-sm text-gray-600 flex items-center">
            <SafeIcon icon={FiBuilding} className="mr-1 text-xs" />
            {client.clientName}
          </p>
        </div>
        <span className={`px-2 py-1 rounded-lg text-xs font-medium border ${status.bg} ${status.text} ${status.border}`}>
          {status.label}
        </span>
      </div>

      {/* Details */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600 flex items-center">
            <SafeIcon icon={FiEuro} className="mr-1 text-xs" />
            Valore Contratto
          </span>
          <span className="font-semibold text-gray-900">
            €{client.contractValue.toLocaleString()}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600 flex items-center">
            <SafeIcon icon={FiCalendar} className="mr-1 text-xs" />
            Data Inserimento
          </span>
          <span className="text-sm text-gray-900">
            {format(client.createdAt, 'dd MMM yyyy', { locale: it })}
          </span>
        </div>

        {client.commission && (
          <div className="flex items-center justify-between p-3 bg-emerald-50 rounded-lg border border-emerald-200">
            <span className="text-sm font-medium text-emerald-700">
              Commissione Maturata
            </span>
            <span className="font-bold text-emerald-700">
              €{client.commission.toLocaleString()}
            </span>
          </div>
        )}

        {client.notes && (
          <div className="pt-3 border-t border-gray-100">
            <p className="text-xs text-gray-600 flex items-start">
              <SafeIcon icon={FiFileText} className="mr-1 mt-0.5 text-xs flex-shrink-0" />
              <span className="line-clamp-2">{client.notes}</span>
            </p>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ClientCard;